(function () {
  'use strict';
  var box = document.querySelector('[data-jps-product-shipping]');
  var picker = document.getElementById('variantSel');
  if (!box || !picker) return;
  function update() {
    var option = picker.options[picker.selectedIndex];
    var price = option && Number(option.getAttribute('data-price-cents'));
    if (!option || !option.value || !Number.isFinite(price)) return;
    box.querySelector('[data-jps-shipping-headline]').textContent = box.getAttribute(price > 59900 ? 'data-air' : price >= 19900 ? 'data-ground' : 'data-below');
  }
  picker.addEventListener('change', update);
  update();
})();
